import React from 'react';
import useModal from './useModal';
import styled from "@emotion/styled"
import ModalContent from './modalContent';
import * as Mixins from '../mixins';

const ModalButton = styled.p`
  font-family: "Saira Condensed", sans-serif;
  font-size: 18px;
  text-decoration: underline;
  color: ${props => props.textColor};
  cursor: pointer;
  &.modal_button_button {
    text-decoration: none;
    padding: .5rem 1rem;
    border-radius: 5px;
    background-color: ${props => props.backgroundColor};
  }
`

const ModalV2 = ({data}) => {
  const { isShowing, toggle } = useModal();
  return (
    <>
      <ModalButton 
        className={`modal_button modal_button_${data.modal_button_type}`}
        textColor={data.modal_button_text_color || Mixins.palette.white}  
        backgroundColor={data.modal_button_background_color || Mixins.palette.greenTwo}
        role='button'
        onClick={toggle}
        onKeyDown={(e) => {
          if (e.nativeEvent.code === 'Space' || e.nativeEvent.code === 'Enter') {
            toggle();
          }
        }}
      >
        {data.modal_button_text}
      </ModalButton>
      <ModalContent
        isShowing={isShowing}
        hide={toggle}
        modalContent={data.modal_content_blocks}
        textColor={data.modal_content_text_color}
        backgroundColor={data.modal_content_background_color}
        transitionType={data.modal_transition_type}
      />
    </>
  )
}

export default ModalV2;